const pageShopVersion = {
  displayField: 'titleAdmin',
  name: 'Page (Shop Version)',
  description: 'Landing pages for shops.  Add appropriate Contentful tags to determine where it will display.',
  fields: [
    {
      id: 'titleAdmin',
      name: 'Admin Title',
      type: 'Symbol',
      localized: false,
      required: true,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'title',
      name: 'Title',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'slug',
      name: 'Slug',
      type: 'Symbol',
      localized: false,
      required: true,
      validations: [
        {
          prohibitRegexp: { pattern: '^/', flags: null },
          message: "Can't start with a slash"
        }
      ],
      disabled: false,
      omitted: false
    },
    {
      id: 'headerType',
      name: 'Header Type',
      type: 'Symbol',
      localized: false,
      required: true,
      validations: [ { in: [ 'None', 'Only Logo', 'Full Navigation' ] } ],
      defaultValue: { 'en-US': 'Full Navigation' },
      disabled: false,
      omitted: false
    },
    {
      id: 'footerType',
      name: 'Footer Type',
      type: 'Symbol',
      localized: false,
      required: true,
      validations: [ { in: [ 'None', 'Full Navigation' ] } ],
      defaultValue: { 'en-US': 'Full Navigation' },
      disabled: false,
      omitted: false
    },
    {
      id: 'category',
      name: 'Category',
      type: 'Array',
      localized: false,
      required: false,
      validations: [],
      disabled: true,
      omitted: false,
      items: {
        type: 'Link',
        validations: [ { linkContentType: [ 'category' ] } ],
        linkType: 'Entry'
      }
    },
    {
      id: 'heroImg',
      name: 'Hero Image',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkMimetypeGroup: [ 'image' ] } ],
      disabled: true,
      omitted: false,
      linkType: 'Asset'
    },
    {
      id: 'seo',
      name: 'Seo',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'seoPage' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'contentBlocks',
      name: 'Content Blocks',
      type: 'Array',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      items: {
        type: 'Link',
        validations: [
          {
            linkContentType: [
              'shopGridCarousel',
              'shortTextAndImage',
              'video',
              'videoGallery',
              'bigPictureCta',
              'stackedTextImageBlock',
              'textAndImageBlock',
              'variantStackedTextImageBlock',
              'flexCollar',
              'introTextBlock',
              'searchHero',
              'interiorHero',
              'threeColumn',
              'threeColumnContent',
              'wideTextImage',
              'blogHomepageFeaturedArticles',
              'shopNewestListings',
              'featuredPropertiesByLifestyle',
              'WideStackedTextImageBlock',
              'threeColumnTeams',
              'clientTestimonials',
              'contactForm',
              'statBlock',
              'valuePropCarousel',
              'jazzHr',
              'richText',
              'newsletterForm',
              'mediaContactInfo',
              'nearbyListings',
              'genericEmbed',
              'threeColumnLeadership'
            ]
          }
        ],
        linkType: 'Entry'
      }
    }
  ],
  metadata: {
    annotations: {
      ContentType: [
        {
          sys: {
            id: 'Contentful:AggregateRoot',
            type: 'Link',
            linkType: 'Annotation'
          }
        }
      ]
    }
  },
  sys: {
    id: 'pageShopVersion',
    version: 18,
    updatedAt: '2024-01-22T19:33:33.401Z'
  }
};
export default pageShopVersion;